import { defineStore } from "pinia";
import api from "@/services/api";

export const useStudentStore = defineStore("student", {
  state: () => ({
    student: null,
    loading: false,
  }),

  actions: {
    // 🚀 Student Profile Fetch
    async fetchStudent() {
      try {
        this.loading = true;
        const token = localStorage.getItem("authToken");

        if (!token) {
          console.warn("⚠️ No auth token found");
          return null;
        }

        const res = await api.get("/student/profile", {
          headers: { Authorization: `Bearer ${token}` },
        });

        this.student = res.data.student;
        return this.student;
      } catch (err) {
        console.error("Failed to fetch student:", err);
        return null;
      } finally {
        this.loading = false;
      }
    },

    // 🚀 Update Student Profile
    async updateStudent(formData) {
      try {
        this.loading = true;
        const token = localStorage.getItem("authToken");

        const res = await api.post(
          `/students/${this.student.id}/update`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );

        this.student = res.data.data; // ✅ Update store
        return { success: true, message: res.data.message };
      } catch (err) {
        console.error("Failed to update student:", err);
        return { success: false, message: "Update failed" };
      } finally {
        this.loading = false;
      }
    },

    // 🚀 Save login user (after login API success)
    setStudent(user, token) {
      this.student = user;
      localStorage.setItem("authToken", token);
      localStorage.setItem("user", JSON.stringify(user));
    },

    // 🚀 Logout
    logout() {
      this.student = null;
      localStorage.removeItem("authToken");
      localStorage.removeItem("user");
    },
  },
});
